import { create } from "zustand";
import { apiRequest } from "services/api";
import { ProductModel } from "modules/product/model";

export interface ProductListStateModel {
  loading: boolean;
  products: ProductModel[];
  error: any | null;
}

interface ProductListStore extends ProductListStateModel {
  productListLoad: (organizationUnitUuid: string) => Promise<void>;
}

export const useProductListStore = create<ProductListStore>((set) => ({
  loading: false,
  products: [],
  error: null,

  productListLoad: async (organizationUnitUuid) => {
    set({ loading: true });
    try {
      const data = await apiRequest({
        endpoint: `/organization-units/${organizationUnitUuid}/products`,
        method: "get",
      });
      set({ products: data, loading: false });
    } catch (error) {
      set({ loading: false, error });
    }
  },
}));
